import React from 'react';

const pageContainer: React.CSSProperties = {
  minHeight: '100vh',
  backgroundColor: '#261136',
  padding: 24,
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

const shellCard: React.CSSProperties = {
  width: '100%',
  maxWidth: 900,
  background:
    'radial-gradient(circle at top, #3A1F52 0, #170824 45%, #12061f 100%)',
  borderRadius: 16,
  padding: 24,
  boxSizing: 'border-box',
  boxShadow: '0 18px 45px rgba(0,0,0,0.45)',
  color: '#F5F5FA',
};

const sectionHeader: React.CSSProperties = {
  color: '#AAB5E0',
  fontSize: 20,
  marginTop: 24,
  marginBottom: 8,
};

const text: React.CSSProperties = {
  color: '#FFF',
  fontSize: 14,
  marginTop: 8,
  opacity: 0.95,
  lineHeight: 1.6,
};

const ContractPage: React.FC = () => {
  return (
    <div style={pageContainer}>
      <div style={shellCard}>
        <h1 style={{ fontSize: 22, fontWeight: 600, marginBottom: 16 }}>
          Lease Agreement
        </h1>

        <div style={text}>
          NOTICE: YOUR STORED PROPERTY MAY BE SUBJECT TO A CLAIM OF LIEN FOR UNPAID RENT AND OTHER CHARGES
          AND MAY BE SOLD TO SATISFY THE LIEN IF THE RENT OR OTHER CHARGES DUE REMAIN UNPAID FOR FOURTEEN
          (14) CONSECUTIVE DAYS. THIS LIEN AND ITS ENFORCEMENT IS AUTHORIZED BY CHAPTER 10 (COMMENCING WITH
          SECTION 21700) OF THE CALIFORNIA BUSINESS AND PROFESSIONS CODE.
        </div>

        <div style={sectionHeader}>Parties and Date</div>
        <div style={text}>
          PARTIES AND DATE: This Lease Agreement (“Lease”) is entered into as of the date set forth above by
          and between Container Storage, LLC (“Owner”) and the individual(s) named above (“Occupant”), for the
          purpose of renting space for storage of personal property, and with the express understanding and
          agreement that no bailment or deposit for safekeeping is intended thereby.
        </div>

        <div style={sectionHeader}>Space</div>
        <div style={text}>
          SPACE: Owner agrees to let, and Occupant agrees to rent those premises described as a storage space
          at Owner&apos;s facility at 855 Parr Blvd. Richmond, CA. (“Storage Facility”), in the number of
          which is set forth in Section 1 above (“Space”), on the terms and conditions of this Lease.
        </div>

        <div style={sectionHeader}>Term</div>
        <div style={text}>
          TERM: The term of this Lease shall commence as of the date set forth in Section 1 of this Lease, and
          shall continue on a month-to-month basis.
        </div>

        <div style={sectionHeader}>Rent</div>
        <div style={text}>
          RENT: Rent shall be payable in advance at the rate set forth in Section 1, on or before the first of
          every month. Rent shall be delinquent if not paid monthly by the day immediately following the
          anniversary date. Rent shall be paid to Owner at the address set forth in this Lease or to such
          other place as Owner may designate in writing. Rent payments shall be made in full without offset or
          deductions of any kind, and without demand. Prior to taking possession of the Space and as a
          condition of taking possession, Occupant shall pay rent for the first month. The monthly rental rate
          may be changed at any time by Owner giving thirty (30) days written notice to Occupant at the
          address set forth in this Lease. Any such adjustment in the monthly rent shall not otherwise affect
          the terms of this Lease, and all other terms of this Lease shall remain in full force and effect.
        </div>

        <div style={sectionHeader}>Permitted and Prohibited Use</div>
        <div style={text}>
          PERMITTED AND PROHIBITED USE OF SPACE: Occupant agrees to use Space only for the storage of property
          wholly owned by Occupant. Property is stored under the supervision and control of Occupant. Owner
          does not exercise care, custody or control over Occupant’s stored property. Occupant specifically
          agrees that, with the exception of property prohibited by this agreement, Owner is not concerned
          with the kind, quality or value of the goods stored. OCCUPANT AGREES NOT TO STORE PROPERTY WITH A
          TOTAL VALUE IN EXCESS OF $5,000.00 WITHOUT PRIOR CONSENT OF OWNER, WHICH CONSENT MAY BE WITHHELD IN
          OWNER’S SOLE DISCRETION AND, IF SUCH WRITTEN CONSENT IS NOT OBTAINED, THE TOTAL VALUE OF OCCUPANT’S
          PROPERTY SHALL BE DEEMED NOT TO EXCEED $5,000.00. The provisions of this paragraph do not alter the
          releases of Owner’s liability set forth in Section 9, above, nor constitute any admission that
          Occupant’s stored property has any value whatsoever. Occupant shall not store any motor vehicle in
          the Space without the prior written consent of Owner. Occupant shall not conduct any activity in or
          around nor store any property in the Space, which would result in violation of any ordinance,
          statute, or regulation of any governmental agency having jurisdiction, or permit such actions to
          occur. Occupant is strictly prohibited from storing or using materials on the premises that are
          classified as hazardous or toxic under any local, state or federal law or regulation, and from
          engaging in any activity on-site which produces such materials. Occupant’s obligations of indemnity
          as set forth in Section 10 herein specifically includes any cost, expenses, fines or penalties
          imposed against Owner, arising out of storage or use of any hazardous or toxic material by Occupant,
          Occupant’s agents, employees, invitees or guests. Occupant shall not use the premises for the
          storage of illegal substances, perishable or food items, explosives, paint, varnish, thinner,
          gasoline and/or other highly flammable materials. The Space shall not be used for operation for any
          business, for manufacturing or production or for human or animal occupancy. Pets shall not be brought
          on the premises or the surrounding property. Occupant shall not do or permit to be done any act that
          interferes with another tenant&apos;s quiet use and enjoyment of his or her space or that creates or
          may create a nuisance at the Facility. Trash or other materials shall not be left in or near the
          Space.
        </div>

        <div style={sectionHeader}>Additional Rental Charges</div>
        <div style={text}>
          ADDITIONAL RENTAL CHARGES: Late rental payments or rent checks that are dishonored cause Owner to
          incur damages, which are extremely difficult to measure, and not contemplated by this Lease. Rent is
          due on the first day of each month, and is delinquent on the day immediately following that date. If
          rent is not received by Owner by the fourteenth day of the month, if Occupant’s check is dishonored
          and returned, or if Occupant’s unit becomes subject to lien enforcement procedures under the
          Self-Service Storage Facilities Act, Occupant agrees to pay to Owner, as additional rent,
          administrative charges as follows:
        </div>
        <div style={text}>
          LATE CHARGES - $10.00 for monthly rent up to $60.00, $15.00 for monthly rent up to $100.00, $20.00
          or 15% for monthly rent of $100.00 or more (whichever is greater) | OTHER CHARGES - Dishonored check
          charge: $20.00, Lien advertising charge: $25.00, Labor charge (hourly rate): $35.00
        </div>
        <div style={text}>
          The receipt of a check shall not be considered payment to Owner if the check is dishonored or not
          paid for any reason. Occupant’s property may become subject to a lien if rent remains unpaid for
          fourteen (14) consecutive days or longer. (California Business and Professions Code Section 21700 et
          seq.) In addition, Occupant agrees to reimburse Owner for all costs incurred by Owner in enforcing
          the lien, including but not limited to the costs of removing locks, inventory of stored property and
          reasonable storage costs as may be provided by law. In the event of satisfaction of the lien prior
          to sale, Owner shall have three (3) days thereafter, in which to release liened property, which may
          have been removed or re-secured during lien enforcement. ALL PAYMENTS MADE TO SATISFY OUTSTANDING
          LIEN AMOUNTS AND CHARGES SHOULD BE PAID BY CERTIFIED CHECK, CASHIER’S CHECK OR CASH. If Occupant’s
          checks are dishonored more than once, Owner may require, upon thirty (30) days written notice to
          Occupant, that all future rent shall be paid by certified check, cashier’s check or cash. If
          Occupant is delinquent, Occupant’s access will be limited to posted office hours only. Any other
          costs incurred by Owner by reason of Occupant’s breach of any provision of this Lease shall be
          deemed additional rent, and may be demanded by Owner of Occupant at any time, or waived, all in
          Owner’s sole and absolute discretion.
        </div>

        <div style={sectionHeader}>Insurance</div>
        <div style={text}>
          INSURANCE: OCCUPANT ACKNOWLEDGES THAT OWNER DOES NOT PROVIDE INSURANCE COVERING OCCUPANT’S STORED
          PROPERTY. OCCUPANT AGREES TO MAINTAIN, AT OCCUPANT’S EXPENSE, A POLICY OF FIRE AND EXTENDED COVERAGE
          INSURANCE WITH THEFT, VANDALISM, AND MALICIOUS MISCHIEF ENDORSEMENTS FOR THE FULL VALUE OF
          OCCUPANT&apos;S STORED PROPERTY. TO THE EXTENT OCCUPANT DOES NOT MAINTAIN SUCH INSURANCE, OCCUPANT
          SHALL BE DEEMED TO HAVE “SELF-INSURED” (I.E., NOT TO INSURE WITH ANY DULY LICENSED INSURANCE
          COMPANY) AND SHALL BE BEAR ALL RISK OF LOSS OR DAMAGE. THIS INSURANCE IS A MATERIAL CONDITION OF THIS
          AGREEMENT AND IS FOR THE BENEFIT OF BOTH OCCUPANT AND OWNER, OCCUPANT EXPRESSLY AGREES THAT THE
          CARRIER OF SUCH INSURANCE SHALL NOT BE SUBROGATED TO ANY CLAIM OF OCCUPANT AGAINST OWNER, OR OWNER’S
          AGENTS OR EMPLOYEES. OCCUPANT AGREES TO INDEMNIFY AND HOLD HARMLESS OWNER FROM ANY EXPENSE, COST, OR
          DAMAGE RESULTING FROM ANY CLAIM OR ACTION BASED IN WHOLE OR IN PART UPON SUCH SUBROGATION. WHILE
          CERTAIN INFORMATION MAY BE MADE AVAILABLE TO OCCUPANT WITH RESPECT TO INSURANCE, OWNER AND OWNER’S
          AGENTS ARE NOT INSURERS, ARE NOT AFFILIATED WITH ANY INSURER, AND RECEIVE NO BENEFIT FROM ANY
          INSURER.
        </div>

        <div style={sectionHeader}>Release of Owner’s Liability</div>
        <div style={text}>
          RELEASE OF OWNER’S LIABILITY: AS A FURTHER CONSIDERATION FOR THE USE AND OCCUPANCY OF THE SPACE,
          OCCUPANT AGREES THAT OWNER, ITS AGENTS AND EMPLOYEES SHALL NOT BE LIABLE TO OCCUPANT, HIS/HER
          AGENTS, GUESTS, LICENSEES, OR INVITEES FOR ANY LOSS OR DAMAGE, INJURY, OR DEATH CAUSED TO THEM OR TO
          THEIR PROPERTY, AS THE RESULT OF THE USE AND OCCUPANCY OF THE SPACE OR THE FACILITY. IT IS FURTHER
          AGREED THAT ANY STORED PROPERTY IS PLACED IN THE SPACE AT OCCUPANT’S SOLE RISK. THE OWNER AND OWNER’S
          AGENTS, EMPLOYEES, AND ASSIGNS SHALL HAVE NO RESPONSIBILITY OR LIABILITY FOR ANY LOSS OR DAMAGE TO
          SAID PROPERTY FROM ANY CAUSE WHATSOEVER, INCLUDING THE ACTIVE OR PASSIVE ACTS, OMISSIONS OR
          NEGLIGENCE OF OWNER OR OWNER’S AGENTS, EMPLOYEES, OR ASSIGNS. OCCUPANT ACKNOWLEDGES THAT OWNER DOES
          NOT WARRANT OR REPRESENT THAT STORED PROPERTY WILL BE SAFELY KEPT, NOR THAT IT WILL BE SECURE
          AGAINST HAZARDS CAUSED BY RODENTS, INSECTS, WATER, FIRE OR THE ELEMENTS OF WEATHER OR EARTHQUAKE. IT
          IS AGREED BY OCCUPANT THAT THIS RELEASE OF OWNER’S LIABILITY IS A BARGAINED FOR CONDITION OF THE RENT
          SET FORTH HERE, AND THAT WERE OWNER NOT RELEASED FROM LIABILITY AS SET FORTH HERE, A MUCH HIGHER RENT
          WOULD HAVE TO BE AGREED UPON. FURTHERMORE, OWNER AND OWNER’S AGENTS OR EMPLOYEES SHALL NOT BE LIABLE
          TO OCCUPANT FOR INJURY OR DEATH SUFFERED BY ANY PERSON, INCLUDING OCCUPANT’S GUESTS OR INVITEES,
          OCCURRING IN OR ABOUT THE PREMISES OR THE SPACE, OR ARISING OUT OF OCCUPANT&apos;S USE OF THE
          PREMISES OR THE SPACE, FROM ANY CAUSE WHATSOEVER, EVEN IF SUCH INJURY OR DEATH IS CAUSED BY THE
          ACTIVE OR PASSIVE ACTS OR OMISSIONS, OR ACTIVE OR PASSIVE NEGLIGENCE OF OWNER, OR OWNER’S AGENTS OR
          EMPLOYEES. THIS RELEASE OF LIABILITY SPECIFICALLY EXTENDS TO ANY LOSSES OR INJURY RESULTING FROM ANY
          FAILURE IN ANY SECURITY SYSTEMS OR SECURITY PROCEDURES EMPLOYED AT THE PREMISES FROM ANY CAUSE
          WHATSOEVER.
        </div>

        <div style={sectionHeader}>Indemnification</div>
        <div style={text}>
          INDEMNIFICATION: Occupant will indemnify, hold harmless and defend Owner from all claims, demands,
          actions or causes of action (including attorney&apos;s fees and all costs whatsoever) that are
          hereafter made or brought as a result of or arising out of Occupant&apos;s use of the Space and the
          Facility. This indemnity specifically includes, but is not limited to, all liabilities released by
          Occupant in Section 9 of this Lease.
        </div>

        <div style={sectionHeader}>Notices, Change of Address, Change in Terms</div>
        <div style={text}>
          NOTICES-CHANGE OF ADDRESS-CHANGE IN TERMS: ALL NOTICES REQUIRED OR PERMITTED BY LAW OR BY THIS
          AGREEMENT MAY BE SENT TO OCCUPANT AT THE ADDRESSES SET FORTH FOR OCCUPANT IN SECTION 1 OF THIS LEASE.
          IN THE EVENT THAT ANY OF THE ADDRESSES GIVEN ABOVE CHANGE, SUCH CHANGE SHALL NOT BE BINDING UPON
          OWNER UNLESS OCCUPANT HAS GIVEN OWNER WRITTEN NOTIFICATION OF THE CHANGE, EITHER BY PERSONAL DELIVERY
          OR BY DEPOSIT IN THE UNITED STATES MAIL WITH FIRST CLASS POSTAGE PREPAID ADDRESSED TO OWNER AT THE
          ADDRESS GIVEN FOR PAYMENT OF RENT AND THE OWNER HAS ACKNOWLEDGED ITS RECEIPT IN WRITING. ANY OF THE
          TERMS OF THIS AGREEMENT MAY BE CHANGED BY OWNER BY WRITTEN NOTICE TO OCCUPANT SEVEN (7) DAYS PRIOR TO
          EXPIRATION OF ANY MONTH OF THE TENANCY.
        </div>

        <div style={sectionHeader}>Conduct</div>
        <div style={text}>
          CONDUCT: Should Occupant appoint another person(s) or organization(s) to enter the Space, Occupant
          shall be responsible for the conduct of such person(s) or organization(s). Owner shall assume that
          possession of a key and gate code is evidence of authority to enter Occupant’s Space. All information
          provided by Occupant on this Lease is confidential and will not knowingly be disclosed to anyone
          without Occupant’s prior consent, except for law enforcement purposes or in response to a lawfully
          issued subpoena.
        </div>

        <div style={sectionHeader}>Condition of Space / Repairs</div>
        <div style={text}>
          CONDITION OF SPACE/REPAIRS-COMMENCEMENT AND TERMINATION: Occupant acknowledges that Occupant has
          inspected the Space and found the Space to be in good repair and in clean and sanitary condition.
          Occupant agrees to maintain the Space in the same condition throughout the term of this Lease.
          Occupant will immediately notify Owner of any defect in the Space. Occupant shall not build on nor
          attach anything to the inside or outside walls, ceiling or floors of the Space. Upon termination of
          this Lease, Occupant shall remove all Occupant’s property from the Space and shall immediately
          deliver possession of the Space to Occupant in the same condition as delivered to Occupant on the
          commencement date of this Lease, reasonable wear and tear excepted. Occupant agrees to leave said
          storage Space broom clean and damage free. Occupant further agrees to remove all items from the Space
          and agrees to reimburse Owner for any/all costs of emptying or repairing Space, which includes but is
          not limited to dump fees, labor, materials and transportation. Occupant agrees to reimburse Owner
          within five (5) days of receipt of an itemized statement of all labor and other expenses incurred to
          dispose of said items. Occupant shall pay the costs of any repairs made necessary by Occupant, or
          his/her guests or agents, ordinary wear and tear excepted, during the term of this Lease. Owner may
          require Occupant to pay the estimated costs of any repairs to be made at Occupant’s expense prior to
          the work being done. Occupant shall pay such expense, whether estimated or actual, within ten (10)
          days of being billed, and such costs shall be additional rent for the purposes of Owner&apos;s
          remedies on default.
        </div>

        <div style={sectionHeader}>Access</div>
        <div style={text}>
          ACCESS: In the Owner’s absolute discretion, Occupant’s access to the Storage Facility and Space may
          be conditioned in any manner deemed reasonably necessary by Owner to maintain order and protect
          security at the Facility. Such measures may include, but are not limited to, limiting hours of
          operation, and requiring verification of Occupant’s identity.
        </div>

        <div style={sectionHeader}>Owner&apos;s Right to Enter or Inspect</div>
        <div style={text}>
          OWNER&apos;S RIGHT TO ENTER OR INSPECT: Occupant grants Owner, Owner’s agents or representatives of
          any governmental authority, including but not limited to, police, fire, health or emergency response
          officials, access to the Space upon three (3) days prior written notice to Occupant. In the event of
          an emergency, Owner, Owner’s agents or representatives of any governmental authority, including but
          not limited to police, fire, health or emergency response officials, shall have the right to remove
          Occupant’s lock and enter the Space, without notice to Occupant and take such actions as may be
          necessary or appropriate to preserve the premises, to comply with applicable law, or enforce any of
          owner’s rights. In the event Occupant’s lock is destroyed in the course of such inspection, Owner
          shall provide and Occupant agrees to accept as Occupant’s sole remedy thereafter, a replacement lock
          of similar kind and quality. Owner shall not be responsible for any loss occasioned by Occupant as a
          result of entry authorized under this section.
        </div>

        <div style={sectionHeader}>Rules</div>
        <div style={text}>
          RULES: Owner shall have the right to establish or change hours of operation or tenant access, or to
          promulgate rules and amendments or amend existing rules and regulations for the safety, care and
          cleanliness of the Facility, or the preservation of good order on the Facility. Occupant agrees that
          such rules are made a part of the agreement and agrees to follow all of Owners Rules now in effect,
          or that may be put into effect from time to time. Except in emergency situations, all changes of the
          Rules and/or facility hours will be conspicuously posted at least seven (7) days prior to the
          effective date of such change. Hours of operation and access to the Facility shall be posted at the
          entrance to the Facility. Current rules will be posted in Owner&apos;s Rental Office.
        </div>

        <div style={sectionHeader}>Termination</div>
        <div style={text}>
          TERMINATION: Owner or Occupant may terminate this Lease by the giving of seven (7) days written
          notice to the other party. Rent is payable by Occupant to Owner for the entire thirty (30) day period
          prior to termination, whether or not Occupant vacates the Space prior to end of the period. Occupant
          agrees to vacate the Space on or before 5:00 P.M. on the last day of the term. In addition, upon
          nonpayment of the rent for fourteen (14) consecutive days, Owner may terminate this Lease upon
          fourteen (14) days written notice pursuant to a Preliminary Lien Notice, as set forth in California
          Business and Professions Code Section 21703, et seq.
        </div>

        <div style={sectionHeader}>Occupant’s Breach</div>
        <div style={text}>
          OCCUPANT’S BREACH: In the event Occupant breaches this Lease, Owner shall be allowed, at Owner’s
          discretion, but not by way of limitation, to exercise any or all remedies provided herein or at law
          or in equity. If it shall become necessary for Owner to institute legal action for the purpose of
          enforcing its rights of lien foreclosure in a civil court of proper jurisdiction, and the Owner
          prevails in such action, Occupant agrees to pay Owner an additional sum of Two Hundred Fifty Dollars
          ($250.00) as liquidated damages.
        </div>

        <div style={sectionHeader}>Assignment</div>
        <div style={text}>
          ASSIGNMENT: Occupant shall not sublet or assign the Space nor store property owned by others without
          the prior written consent of Owner. This provision shall be strictly enforced.
        </div>

        <div style={sectionHeader}>Security of Space / Locks</div>
        <div style={text}>
          SECURITY OF SPACE/LOCKS: Owner will provide Occupant with a cylinder lock for Spaces with all roll-up
          doors and will maintain an extra key. IN ADDITION, OCCUPANT MUST PROVIDE THEIR OWN LOCK. Occupant
          agrees to be solely responsible for providing such locks, as Occupant desires for securing access to
          the Space. In the event such locks or security devices are rendered ineffectual for their intended
          purpose from any cause, or the Space is rendered insecure in any manner, Owner may, at its sole
          option, take whatever measures are deemed reasonably necessary by Owner to resecure the access to the
          Space. Owner is not responsible for taking any measures whatsoever, nor for notifying Occupant that
          access to the Space has become insecure. The fact that Owner has taken measures to resecure the
          access to the Space under this paragraph shall not alter the release of Owner’s liability set forth
          in Section 9 of this Lease, nor shall such measures be deemed conversion of Occupants stored
          property.
        </div>

        <div style={sectionHeader}>Miscellaneous</div>
        <div style={text}>
          MISCELLANEOUS: Time is of the essence of this Lease and of each provision of this Lease. Words used
          in the singular shall include the plural where the context requires. All rights, powers, options, and
          remedies given or granted to Owner by this Lease, or by law, are cumulative, and no one of them is
          exclusive of another. If any provision of this Lease is held by a court to be void, or
          unenforceable, the other provisions shall remain in full force and effect.
        </div>

        <div style={sectionHeader}>No Oral Agreements</div>
        <div style={text}>
          NO ORAL AGREEMENTS: This rental agreement contains the entire agreement between Owner and Occupant,
          and no oral agreement shall be of any effect whatsoever. Occupant agrees that he/she is not relying,
          and will not rely, upon any oral representation made by Owner or by any of Owners agents or
          employees purporting to modify or add to this agreement in any way whatsoever. Occupant agrees that
          this agreement may be modified only in writing, signed by both parties, in order for such a
          modification to have any effect whatsoever. Owner’s employees have been forbidden from providing any
          service on behalf of Owner. Should employees of Owner provide service at Occupant’s request such
          employee shall be deemed to be the agent of Occupant regardless of whether payment for such services
          is made or not, and Occupant agrees to hold Owner harmless from all liability in connection with or
          arising from directly or indirectly, such services performed by employee of Owner.
        </div>

        <div style={sectionHeader}>Entire Agreement</div>
        <div style={text}>
          ENTIRE AGREEMENT: There are no other terms, conditions, or agreements, expressed or implied, written
          or oral, between Occupant and Owner, their agents, or employees that extend, limit, or in anyway
          modify the terms, covenants, and conditions of this Lease. This Lease may be amended, modified, or
          supplemented only by writing signed by both parties. Any purported oral amendment, modification, or
          supplement is void.
        </div>

        <div style={sectionHeader}>Deposit Refund</div>
        <div style={text}>
          DEPOSIT REFUND: Vacated unit must be left clean and no trash left outside. Cylinder lock with key
          (roll up doors) must be returned to office. Any past due rent will be deducted from deposit. OWNER
          DOES NOT FURNISH ANY TRASH SERVICE.
        </div>

        <div style={sectionHeader}>Rental Refund</div>
        <div style={text}>
          RENTAL REFUND: Owner will prorate rent only after receiving written notice at least seven (7) days in
          advance of vacating the Space. There is no rent proration during the first sixty (60) days of the
          tenancy.
        </div>
      </div>
    </div>
  );
};

export default ContractPage;
